module.exports = __webpack_public_path__ + "static/media/adver-pic.f4f40e48.png";